<template>
  <el-dialog
    title="删除计算规则"
    :visible.sync="isShow"
    width="400px"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <div class="delete-tips">
      <i class="el-icon-warning-outline"></i>
      <span>确定要删除规则「{{ ruleName }}」吗？</span>
    </div>
    <div class="delete-warning">提示：删除后数据不可恢复，请谨慎操作！</div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose"> 取消 </el-button>
      <el-button type="danger" @click="handleDelete"> 确认删除 </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { deleteCalcRule } from "@/api/community/calcRuleApi";

export default {
  name: "DeleteCalcRule",
  data() {
    return {
      isShow: false,
      ruleId: "", // 要删除的规则ID
      ruleName: "", // 规则名称（用于提示）
    };
  },
  methods: {
    // 打开弹窗
    open(rule) {
      this.ruleId = rule.ruleId;
      this.ruleName = rule.ruleName;
      this.isShow = true;
    },

    // 关闭弹窗
    handleClose() {
      this.isShow = false;
    },

    // 确认删除
    async handleDelete() {
      try {
        await deleteCalcRule({
          ruleId: this.ruleId,
        });
        this.$message.success("删除规则成功");
        this.isShow = false;
        this.$emit("success"); // 通知父组件刷新
      } catch (error) {
        console.error("删除规则失败:", error);
        this.$message.error("删除规则失败，请重试");
      }
    },
  },
};
</script>

<style scoped>
.delete-tips {
  display: flex;
  align-items: center;
  color: #e6a23c;
  margin-bottom: 15px;
  font-size: 14px;
}

.delete-tips i {
  font-size: 20px;
  margin-right: 10px;
}

.delete-warning {
  color: #666;
  font-size: 13px;
  line-height: 1.5;
}

.dialog-footer {
  text-align: right;
  margin-top: 20px;
}
</style>
